<template>
    <div class="collateral-select-widget">
        <div class="widget-header">
            <div class="title-container">
                <h3>Select Collateral</h3>
            </div>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <collateral-display 
                :locked-filter="options.filter"
                :filterable="options.filterable"
                :selector="options.selector"
                :account-id="options.accountId"
                :client-id="options.clientId"
                :agency-id="options.agencyId"
                :selectable="false"
                :primary="true"
                searchable
                @select="select($event)"
                @remove="remove($event)" />
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" @click="closeWidget">
                    Cancel
                </app-button>
            </div>
            <div class="action-container">
                <app-button @click="add">
                    Add
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const CollateralSelect = () => import('@/components/collateral/collateral-display');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'collateral-select-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'collateral-display': CollateralSelect
    },

    props: {
        widget: {
            type: Object,
            required: true
        },

        options: {
            type: Object
        }
    },

    data() {
        return {
            selectedItem: null,
        }
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        select(item) {
            this.selectedItem = item;
        },

        remove() {
            this.selectedItem = null;
        },

        add() {
            if (this.selectedItem) {
                if(this.options.eventName){
                    EventBus.$emit(this.options.eventName, this.selectedItem);
                } else {
                    EventBus.$emit('collateral:select', this.selectedItem);
                }
            }
            
            this.closeWidget();
        }
    }
}
</script>

<style>
.collateral-select-widget .content-wrapper {
    padding: 20px;
}

.collateral-select-widget .transparent-btn {
    background: transparent;
    color: #877D88;
}

.collateral-select-widget .transparent-btn:hover {
    background: #E1E0E5;
}

.collateral-select-widget .collateral-display .master-card-wrapper > .card {
    margin-right: 11px;
}

.collateral-select-widget .master-display.collateral-display .master-card-controls .custom-filter-container {
    right: -200px;
}
</style>